<!-- 手机验证码 -->
<template>
    <div v-if="componentsData.type == 8">
        <div class="bg-div" :style="bgStyle">
            <template v-if="componentsData.content.select_style == 1">
                <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                    {{ componentsData.content.title }}
                </div>
                <div class="pb8" :style="textStyle1">
                    {{ componentsData.content.prompt_text }}
                </div>
                <div class="mt8" :style="titleStyle">验证码</div>
                <div class="mt8 pb8 flex-sb" :style="textStyle1">
                    请输入验证码
                    <Button class="mr8 ml8 h28" :style="buttonStyle">发送</Button>
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == 2">
                <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                    {{ componentsData.content.title }}
                </div>
                <div class="p6 flex-sb h40" :style="textStyle3">
                    {{ componentsData.content.prompt_text }}
                </div>
                <div class="mt8" :style="titleStyle">验证码</div>
                <div class="mt8 p6 flex-sb h40" :style="textStyle3">
                    请输入验证码
                    <Button class="mr8 ml8 h28" :style="buttonStyle">发送</Button>
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == 3">
                <div class="p6 flex-sb h40" :style="textStyle3">
                    <div v-if="componentsData.content.title" :style="titleStyle" class="title-box2">
                        {{ componentsData.content.title }}
                    </div>
                    <div>
                        {{ componentsData.content.prompt_text }}
                    </div>
                </div>
                <div class="mt8 p6 flex-sb h40" :style="textStyle3">
                    <div :style="titleStyle">验证码</div>
                    <div>
                        请输入验证码
                        <Button class="mr8 ml8 h28" :style="buttonStyle"
                            >发送</Button
                        >
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        buttonStyle() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.unsent_button_color,
                color: content.unsent_text_color,
            };
        },
        textStyle1() {
            const content = this.componentsData.content;
            return {
                borderBottom: `1px solid ${content.border_color}`,
                color: content.prompt_text_color,
            };
        },
        textStyle3() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
                border: `1px solid ${content.border_color}`,
                color: content.prompt_text_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.mt8 {
    margin-top: 8px;
}
.pb8 {
    padding-bottom: 8px;
}
.p6 {
    padding: 6px;
}
.mr8 {
    margin-right: 8px;
}
.ml8 {
    margin-left: 8px;
}
.h28 {
    height: 28px;
}
.h40 {
    height: 40px;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
.title-box2 {
    font-size: 18px;
}
</style>